import { Component } from '@angular/core';
import { CourseService } from '../services/course.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add-new-course',
  templateUrl: './add-new-course.component.html',
  styleUrls: ['./add-new-course.component.css']
})
export class AddNewCourseComponent {
  newCourseAssessment: string = '';
  autoCourseCompletion: any = '';

  constructor(private readonly courseService: CourseService, private readonly toastr: ToastrService) {

  }

  addNewCourse() {
    this.courseService.addCourseName(this.newCourseAssessment, this.autoCourseCompletion).subscribe({
      next: data => {
        this.toastr.success('Course was added successfully.', 'Success!');
        this.newCourseAssessment = "";
        this.autoCourseCompletion = "";
      },
      error: error => {
        this.toastr.error('Course could not be added. Please try again later.', 'Error!');
      }
    })
  }
}
